import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const GET_SURVEYS = 'GET_SURVEYS';
export const GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS';
export const GET_SURVEYS_FAIL = 'GET_SURVEYS_FAIL';
export const GET_SURVEYS_RESET = 'GET_SURVEYS_RESET';

export const CREATE_SURVEY = 'CREATE_SURVEY';
export const CREATE_SURVEY_SUCCESS = 'CREATE_SURVEY_SUCCESS';
export const CREATE_SURVEY_FAIL = 'CREATE_SURVEY_FAIL';
export const CREATE_SURVEY_RESET = 'CREATE_SURVEY_RESET';

export const GET_SURVEY_DETAIL = 'GET_SURVEY_DETAIL';
export const GET_SURVEY_DETAIL_SUCCESS = 'GET_SURVEY_DETAIL_SUCCESS';
export const GET_SURVEY_DETAIL_FAIL = 'GET_SURVEY_DETAIL_FAIL';
export const GET_SURVEY_DETAIL_RESET = 'GET_SURVEY_DETAIL_RESET';

export const SEND_SURVEY_PROMPT = 'SEND_SURVEY_PROMPT';
export const SEND_SURVEY_PROMPT_SUCCESS = 'SEND_SURVEY_PROMPT_SUCCESS';
export const SEND_SURVEY_PROMPT_FAIL = 'SEND_SURVEY_PROMPT_FAIL';
export const SEND_SURVEY_PROMPT_RESET = 'SEND_SURVEY_PROMPT_RESET';

export const ADD_SURVEY_QUESTION = 'ADD_SURVEY_QUESTION';
export const ADD_SURVEY_QUESTION_SUCCESS = 'ADD_SURVEY_QUESTION_SUCCESS';
export const ADD_SURVEY_QUESTION_FAIL = 'ADD_SURVEY_QUESTION_FAIL';
export const ADD_SURVEY_QUESTION_RESET = 'ADD_SURVEY_QUESTION_RESET';

export const UPDATE_SURVEY_QUESTION = 'UPDATE_SURVEY_QUESTION';
export const UPDATE_SURVEY_QUESTION_SUCCESS = 'UPDATE_SURVEY_QUESTION_SUCCESS';
export const UPDATE_SURVEY_QUESTION_FAIL = 'UPDATE_SURVEY_QUESTION_FAIL';
export const UPDATE_SURVEY_QUESTION_RESET = 'UPDATE_SURVEY_QUESTION_RESET';

export const DELETE_SURVEY_QUESTION = 'DELETE_SURVEY_QUESTION';
export const DELETE_SURVEY_QUESTION_SUCCESS = 'DELETE_SURVEY_QUESTION_SUCCESS';
export const DELETE_SURVEY_QUESTION_FAIL = 'DELETE_SURVEY_QUESTION_FAIL';
export const DELETE_SURVEY_QUESTION_RESET = 'DELETE_SURVEY_QUESTION_RESET';

export const UPDATE_SURVEY_DEMOGRAPHICS = 'UPDATE_SURVEY_DEMOGRAPHICS';
export const UPDATE_SURVEY_DEMOGRAPHICS_SUCCESS = 'UPDATE_SURVEY_DEMOGRAPHICS_SUCCESS';
export const UPDATE_SURVEY_DEMOGRAPHICS_FAIL = 'UPDATE_SURVEY_DEMOGRAPHICS_FAIL';
export const UPDATE_SURVEY_DEMOGRAPHICS_RESET = 'UPDATE_SURVEY_DEMOGRAPHICS_RESET';

export const SAVE_SURVEY = 'SAVE_SURVEY';
export const SAVE_SURVEY_SUCCESS = 'SAVE_SURVEY_SUCCESS';
export const SAVE_SURVEY_FAIL = 'SAVE_SURVEY_FAIL';
export const SAVE_SURVEY_RESET = 'SAVE_SURVEY_RESET';

export const REGENERATE_QUESTIONS = 'REGENERATE_QUESTIONS';
export const REGENERATE_QUESTIONS_SUCCESS = 'REGENERATE_QUESTIONS_SUCCESS';
export const REGENERATE_QUESTIONS_FAIL = 'REGENERATE_QUESTIONS_FAIL';
export const REGENERATE_QUESTIONS_RESET = 'REGENERATE_QUESTIONS_RESET';

export const REORDER_QUESTIONS = 'REORDER_QUESTIONS';
export const REORDER_QUESTIONS_SUCCESS = 'REORDER_QUESTIONS_SUCCESS';
export const REORDER_QUESTIONS_FAIL = 'REORDER_QUESTIONS_FAIL';
export const REORDER_QUESTIONS_RESET = 'REORDER_QUESTIONS_RESET';

export const COPY_SURVEY = 'COPY_SURVEY';
export const COPY_SURVEY_SUCCESS = 'COPY_SURVEY_SUCCESS';
export const COPY_SURVEY_FAIL = 'COPY_SURVEY_FAIL';
export const COPY_SURVEY_RESET = 'COPY_SURVEY_RESET';

export const DELETE_SURVEY = 'DELETE_SURVEY';
export const DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS';
export const DELETE_SURVEY_FAIL = 'DELETE_SURVEY_FAIL';
export const DELETE_SURVEY_RESET = 'DELETE_SURVEY_RESET';

const authHeaders = () => ({
  Authorization: 'Bearer ' + getUserToken(),
});

export const getSurveys = () => ({ type: GET_SURVEYS });
export const getSurveysSuccess = (response) => ({ type: GET_SURVEYS_SUCCESS, response });
export const getSurveysFail = (response) => ({ type: GET_SURVEYS_FAIL, response });
export const getSurveysReset = () => ({ type: GET_SURVEYS_RESET });

export const createSurvey = () => ({ type: CREATE_SURVEY });
export const createSurveySuccess = (response) => ({ type: CREATE_SURVEY_SUCCESS, response });
export const createSurveyFail = (response) => ({ type: CREATE_SURVEY_FAIL, response });
export const createSurveyReset = () => ({ type: CREATE_SURVEY_RESET });

export const getSurveyDetail = () => ({ type: GET_SURVEY_DETAIL });
export const getSurveyDetailSuccess = (response) => ({ type: GET_SURVEY_DETAIL_SUCCESS, response });
export const getSurveyDetailFail = (response) => ({ type: GET_SURVEY_DETAIL_FAIL, response });
export const getSurveyDetailReset = () => ({ type: GET_SURVEY_DETAIL_RESET });

export const sendSurveyPrompt = () => ({ type: SEND_SURVEY_PROMPT });
export const sendSurveyPromptSuccess = (response) => ({ type: SEND_SURVEY_PROMPT_SUCCESS, response });
export const sendSurveyPromptFail = (response) => ({ type: SEND_SURVEY_PROMPT_FAIL, response });
export const sendSurveyPromptReset = () => ({ type: SEND_SURVEY_PROMPT_RESET });

export const addSurveyQuestion = () => ({ type: ADD_SURVEY_QUESTION });
export const addSurveyQuestionSuccess = (response) => ({ type: ADD_SURVEY_QUESTION_SUCCESS, response });
export const addSurveyQuestionFail = (response) => ({ type: ADD_SURVEY_QUESTION_FAIL, response });
export const addSurveyQuestionReset = () => ({ type: ADD_SURVEY_QUESTION_RESET });

export const updateSurveyQuestion = () => ({ type: UPDATE_SURVEY_QUESTION });
export const updateSurveyQuestionSuccess = (response) => ({ type: UPDATE_SURVEY_QUESTION_SUCCESS, response });
export const updateSurveyQuestionFail = (response) => ({ type: UPDATE_SURVEY_QUESTION_FAIL, response });
export const updateSurveyQuestionReset = () => ({ type: UPDATE_SURVEY_QUESTION_RESET });

export const deleteSurveyQuestion = () => ({ type: DELETE_SURVEY_QUESTION });
export const deleteSurveyQuestionSuccess = (response) => ({ type: DELETE_SURVEY_QUESTION_SUCCESS, response });
export const deleteSurveyQuestionFail = (response) => ({ type: DELETE_SURVEY_QUESTION_FAIL, response });
export const deleteSurveyQuestionReset = () => ({ type: DELETE_SURVEY_QUESTION_RESET });

export const updateSurveyDemographics = () => ({ type: UPDATE_SURVEY_DEMOGRAPHICS });
export const updateSurveyDemographicsSuccess = (response) => ({ type: UPDATE_SURVEY_DEMOGRAPHICS_SUCCESS, response });
export const updateSurveyDemographicsFail = (response) => ({ type: UPDATE_SURVEY_DEMOGRAPHICS_FAIL, response });
export const updateSurveyDemographicsReset = () => ({ type: UPDATE_SURVEY_DEMOGRAPHICS_RESET });

export const saveSurvey = () => ({ type: SAVE_SURVEY });
export const saveSurveySuccess = (response) => ({ type: SAVE_SURVEY_SUCCESS, response });
export const saveSurveyFail = (response) => ({ type: SAVE_SURVEY_FAIL, response });
export const saveSurveyReset = () => ({ type: SAVE_SURVEY_RESET });

export const regenerateQuestions = () => ({ type: REGENERATE_QUESTIONS });
export const regenerateQuestionsSuccess = (response) => ({ type: REGENERATE_QUESTIONS_SUCCESS, response });
export const regenerateQuestionsFail = (response) => ({ type: REGENERATE_QUESTIONS_FAIL, response });
export const regenerateQuestionsReset = () => ({ type: REGENERATE_QUESTIONS_RESET });

export const reorderQuestions = () => ({ type: REORDER_QUESTIONS });
export const reorderQuestionsSuccess = (response) => ({ type: REORDER_QUESTIONS_SUCCESS, response });
export const reorderQuestionsFail = (response) => ({ type: REORDER_QUESTIONS_FAIL, response });
export const reorderQuestionsReset = () => ({ type: REORDER_QUESTIONS_RESET });

export const copySurvey = () => ({ type: COPY_SURVEY });
export const copySurveySuccess = (response) => ({ type: COPY_SURVEY_SUCCESS, response });
export const copySurveyFail = (response) => ({ type: COPY_SURVEY_FAIL, response });
export const copySurveyReset = () => ({ type: COPY_SURVEY_RESET });

export const deleteSurvey = () => ({ type: DELETE_SURVEY });
export const deleteSurveySuccess = (response) => ({ type: DELETE_SURVEY_SUCCESS, response });
export const deleteSurveyFail = (response) => ({ type: DELETE_SURVEY_FAIL, response });
export const deleteSurveyReset = () => ({ type: DELETE_SURVEY_RESET });

export const getSurveysApi = (params) => {
  return (dispatch) => {
    dispatch(getSurveys());
    axios
      .get(`${config.api.base_url}/surveys/list`, {
        params: params,
        headers: authHeaders(),
      })
      .then((response) => dispatch(getSurveysSuccess(response.data)))
      .catch((error) => dispatch(getSurveysFail(error.response?.data || error.message)));
  };
};

export const createSurveyApi = (payload) => {
  return (dispatch) => {
    dispatch(createSurvey());
    axios
      .post(`${config.api.base_url}/surveys/create`, payload, { headers: authHeaders() })
      .then((response) => dispatch(createSurveySuccess(response.data)))
      .catch((error) => dispatch(createSurveyFail(error.response?.data || error.message)));
  };
};

export const getSurveyDetailApi = (surveyId) => {
  return (dispatch) => {
    dispatch(getSurveyDetail());
    axios
      .get(`${config.api.base_url}/surveys/detail/${surveyId}`, { headers: authHeaders() })
      .then((response) => dispatch(getSurveyDetailSuccess(response.data)))
      .catch((error) => dispatch(getSurveyDetailFail(error.response?.data || error.message)));
  };
};

export const sendSurveyPromptApi = (payload) => {
  return (dispatch) => {
    dispatch(sendSurveyPrompt());
    axios
      .post(`${config.api.base_url}/surveys/prompt`, payload, { headers: authHeaders() })
      .then((response) => dispatch(sendSurveyPromptSuccess(response.data)))
      .catch((error) => dispatch(sendSurveyPromptFail(error.response?.data || error.message)));
  };
};

export const addSurveyQuestionApi = (payload) => {
  return (dispatch) => {
    dispatch(addSurveyQuestion());
    axios
      .post(`${config.api.base_url}/surveys/question/add`, payload, { headers: authHeaders() })
      .then((response) => dispatch(addSurveyQuestionSuccess(response.data)))
      .catch((error) => dispatch(addSurveyQuestionFail(error.response?.data || error.message)));
  };
};

export const updateSurveyQuestionApi = (payload) => {
  return (dispatch) => {
    dispatch(updateSurveyQuestion());
    axios
      .post(`${config.api.base_url}/surveys/question/update`, payload, { headers: authHeaders() })
      .then((response) => dispatch(updateSurveyQuestionSuccess(response.data)))
      .catch((error) => dispatch(updateSurveyQuestionFail(error.response?.data || error.message)));
  };
};

export const deleteSurveyQuestionApi = (payload) => {
  return (dispatch) => {
    dispatch(deleteSurveyQuestion());
    axios
      .post(`${config.api.base_url}/surveys/question/delete`, payload, { headers: authHeaders() })
      .then((response) => dispatch(deleteSurveyQuestionSuccess(response.data)))
      .catch((error) => dispatch(deleteSurveyQuestionFail(error.response?.data || error.message)));
  };
};

export const updateSurveyDemographicsApi = (payload) => {
  return (dispatch) => {
    dispatch(updateSurveyDemographics());
    axios
      .post(`${config.api.base_url}/surveys/demographics/update`, payload, { headers: authHeaders() })
      .then((response) => dispatch(updateSurveyDemographicsSuccess(response.data)))
      .catch((error) => dispatch(updateSurveyDemographicsFail(error.response?.data || error.message)));
  };
};

export const saveSurveyApi = (payload) => {
  return (dispatch) => {
    dispatch(saveSurvey());
    axios
      .post(`${config.api.base_url}/surveys/save`, payload, { headers: authHeaders() })
      .then((response) => dispatch(saveSurveySuccess(response.data)))
      .catch((error) => dispatch(saveSurveyFail(error.response?.data || error.message)));
  };
};

export const regenerateQuestionsApi = (payload) => {
  return (dispatch) => {
    dispatch(regenerateQuestions());
    axios
      .post(`${config.api.base_url}/surveys/regenerate`, payload, { headers: authHeaders() })
      .then((response) => dispatch(regenerateQuestionsSuccess(response.data)))
      .catch((error) => dispatch(regenerateQuestionsFail(error.response?.data || error.message)));
  };
};

export const reorderQuestionsApi = (payload) => {
  return (dispatch) => {
    dispatch(reorderQuestions());
    axios
      .post(`${config.api.base_url}/surveys/questions/reorder`, payload, { headers: authHeaders() })
      .then((response) => dispatch(reorderQuestionsSuccess(response.data)))
      .catch((error) => dispatch(reorderQuestionsFail(error.response?.data || error.message)));
  };
};

export const copySurveyApi = (surveyId, title) => {
  return (dispatch) => {
    dispatch(copySurvey());
    axios
      .post(`${config.api.base_url}/surveys/copy/${surveyId}`, { title }, { headers: authHeaders() })
      .then((response) => dispatch(copySurveySuccess(response.data)))
      .catch((error) => dispatch(copySurveyFail(error.response?.data || error.message)));
  };
};

export const deleteSurveyApi = (surveyId) => {
  return (dispatch) => {
    dispatch(deleteSurvey());
    axios
      .post(`${config.api.base_url}/surveys/delete/${surveyId}`, {}, { headers: authHeaders() })
      .then((response) => dispatch(deleteSurveySuccess(response.data)))
      .catch((error) => dispatch(deleteSurveyFail(error.response?.data || error.message)));
  };
};
